import { useLang } from "../../../i18n/LangContext";
import { Button } from "../../ui/button";
import { Pencil, Trash2, Copy, ArrowUp, ArrowDown, Eye, EyeOff } from "lucide-react";
import { L, formatDateID } from "../lib";

const iconBtn = "h-8 w-8 text-slate-300 hover:bg-white/5";

export function CmsDayRow({ day, onMove, onEdit, onDuplicate, onTogglePublish, onDelete }) {
  const { t, lang } = useLang();
  return (
    <div data-testid={`cms-day-row-${day.day_number}`} className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-white/5 bg-[#161923] p-4">
      <span className="h-10 w-10 shrink-0 rounded-lg bg-[#FF3B30]/10 text-[#FF3B30] font-[Outfit] font-extrabold flex items-center justify-center text-sm">{day.day_number}</span>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-white truncate">{L(day.title, lang)}</div>
        <div className="text-[11px] uppercase tracking-widest text-slate-500 mt-0.5">
          {day.status} · {(day.content || []).length} {t("edu.contentItems")}
        </div>
        {day.available_date && (
          <div data-testid={`cms-day-available-${day.day_number}`} className="text-[11px] text-[#10B981] mt-0.5">
            {t("edu.availableDate")}: {formatDateID(day.available_date, lang)}
            {day.schedule_batch?.code ? ` · ${day.schedule_batch.code}` : ""}
          </div>
        )}
      </div>
      <div className="flex gap-1">
        <Button size="icon" variant="ghost" data-testid={`cms-day-up-${day.day_number}`} onClick={() => onMove(-1)} className={iconBtn}><ArrowUp className="h-3.5 w-3.5" /></Button>
        <Button size="icon" variant="ghost" data-testid={`cms-day-down-${day.day_number}`} onClick={() => onMove(1)} className={iconBtn}><ArrowDown className="h-3.5 w-3.5" /></Button>
        <Button size="icon" variant="ghost" data-testid={`cms-day-edit-${day.day_number}`} onClick={onEdit} className={iconBtn}><Pencil className="h-3.5 w-3.5" /></Button>
        <Button size="icon" variant="ghost" data-testid={`cms-day-duplicate-${day.day_number}`} onClick={onDuplicate} className={iconBtn}><Copy className="h-3.5 w-3.5" /></Button>
        <Button size="icon" variant="ghost" data-testid={`cms-day-publish-${day.day_number}`} onClick={onTogglePublish} className={iconBtn}>
          {day.status === "PUBLISHED" ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
        </Button>
        <Button size="icon" variant="ghost" data-testid={`cms-day-delete-${day.day_number}`} onClick={onDelete} className="h-8 w-8 text-red-400 hover:bg-red-500/10"><Trash2 className="h-3.5 w-3.5" /></Button>
      </div>
    </div>
  );
}
